/*
 * @Author: wangcq01
 * @LastEditors: wangcq01
 * @Date: 2020-06-18 16:37:48
 * @LastEditTime: 2020-06-22 15:56:16
 * @FilePath: \dmp-web-v2\src\views\dataview-refactor\chartsdk\components\propComponents\MarklineConfig\helper.js
 * @Description: 模块
 */ 
export const ITEM_CLASS = 'markline-config-item-wrapper'

export const closest = (el, fn) => {
  while (el) {
    // 不需要一直找到根 dom
    if (el.classList && el.classList.contains(ITEM_CLASS)) {
      return null
    }

    if (fn(el)) {
      return el
    }

    el = el.parentNode
  }

  return null
}

export const NodeType = {
  Anchor: 'A',
  Button: 'BUTTON',
  Canvas: 'CANVAS',
  Input: 'INPUT',
  Option: 'OPTION',
  Textarea: 'TEXTAREA',
  Select: 'SELECT',
}

export const shouldCancelStart = (event) => {
  // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
  const interactiveElements = [
    NodeType.Input,
    NodeType.Textarea,
    NodeType.Select,
    NodeType.Option,
    NodeType.Button,
  ]

  if (interactiveElements.indexOf(event.target.tagName) !== -1) {
    // Return true to cancel sorting
    return true
  }

  // 阻止删除按钮
  if (event.target.tagName === 'I' && event.target.classList && event.target.classList.contains('condition-remove')) {
    return true
  }

  return !!closest(event.target, el => el.contentEditable === 'true' ||
    (el.classList && (el.classList.contains('dmp-antd-component') || el.classList.contains('ant-dropdown-trigger'))))
}

export const DEFAULT_LINE = [
  { width: 1, style: 'dotted', color: '#F0454C' },
  { width: 1, style: 'solid', color: '#F0454C' },
  { width: 1, style: 'dotted', color: '#2CD781' },
  { width: 1, style: 'solid', color: '#2CD781' },
  { width: 1, style: 'dotted', color: '#FAB800' },
  { width: 1, style: 'dashed', color: '#FAE300' },
  { width: 1, style: 'dotted', color: '#45ADFF' },
  { width: 1, style: 'dashed', color: '#B651F4' },
]

export const defaultSettings = DEFAULT_LINE[0]

export const LineStyles = [
  { value: 'solid', style: { width: 2, style: 'solid', color: '#979797' } },
  { value: 'dotted', style: { width: 2, style: 'dotted', color: '#979797' } },
  { value: 'dashed', style: { width: 2, style: 'dashed', color: '#979797' } },
]

export const CalcList = [{
  value: 'avg',
  text: '平均值'
}, {
  value: 'max',
  text: '最大值'
}, {
  value: 'min',
  text: '最小值'
}, {
  value: 'percentile',
  text: '百分位数'
}]

export const getCalcName = (key) => {
  const calc = CalcList.find(d => d.value === key)
  return calc && calc.text
}
